<template>
  <div class="fixed flex flex-col items-center top-0 h-screen w-screen pt-20 px-10 pb-10 z-10 bg-white" :class="[show ? 'show-previous-list' : 'hide-previous-list']">
    <div class="flex items-center justify-between w-full mb-2">
      <button class="w-20 h-10 rounded border-2 border-black font-black focus:outline-none hover:shadow-lg button-back" @click="goBack">
        Back
      </button>
      <h1 class="text-3xl font-black">Previous List</h1>
    </div>
    
    <div class="w-full h-full rounded border-2 border-black overflow-y-auto bg-white">
      <div 
        class="w-full align-center p-4 relative"
        v-for="(item, index) in sentences"
        :class="[index % 2 === 0 ? 'bg-white' : 'bg-gray-300']"
        :key="item.id">
        <div class="text-center text-md relative p-2" v-for="items in item.sets" :key="items.id" v-html="hightlighter(item, items)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import { baseUrl } from '@/config';
import { relationExtractionData } from '@/data';
import entityTypes from '@/entityTypes';

export default {
  async created() {
    try {
      const response = await axios.get(baseUrl + '/see_previous_list');

      this.sentences = response.data; //relationExtractionData;
    } catch (err) {
      console.log(err);
    }      
  },
  props: ['show', 'goBack'],
  data() {
    return {
      sentences: ''
    }
  },
  methods: {
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    },
    hightlighter(data, highlighter) {
      let str = data.sentence;
      const words = highlighter;
   
      if (words.entity_1.word) {
        str = str.replace(new RegExp(this.escapeRegExp(words.entity_1.word) + "(?![^<]*</span>)"), match => {
          return `<span style="background: #F6AD55">${match}</span>`;
        });
      }
      if (words.relation.word) {
        str = str.replace(new RegExp(this.escapeRegExp(words.relation.word) + "(?![^<]*</span>)"), match => {
          return `<span style="background: #68D391">${match}</span>`;
        });
      }
      if (words.entity_2.word) {
        str = str.replace(new RegExp(this.escapeRegExp(words.entity_2.word) + "(?![^<]*</span>)"), match => {
          return `<span style="background: #F687B3">${match}</span>`;
        });
      }

      return str;
    },
  },
}
</script>

<style>
.hide-previous-list {
  transform: translateX(100vw);
  transition: linear 300ms;
}

.show-previous-list {
  transform: translateX(0);
  transition: linear 300ms;
}
</style>